import { adminApi } from "src/api";
import { ApiControllers } from "src/api/config";

const getKpiData = (module) => {
    const method = {
        Cards: "cardsdashboardkpi",
        crypto: "exchangedashboardkpi",
        Banks:'bankdashboardkpi',
        Exchange :'exchangedashboardkpi',
        Wallets:'walletsdashboardkpi',
        Payments:'paymentsdashboardkpi',
    }
    return adminApi.get(ApiControllers.dashboardController + method[module]);
}

const getPieChartData= (module)=>{
    const method={
        crypto:'ExchangeCryptoBalancesPieChart',
        Banks:'ExchangeCryptoBalancesPieChart',
        Exchange :'ExchangeCryptoBalancesPieChart',
        Wallets:'ExchangeCryptoBalancesPieChart',
        Cards:'CardsPieChart',
        Payments:'PaymentsCryptoBalancesPieChart',
    }
    return adminApi.get(ApiControllers.dashboardController+method[module])
}
const getBalancesChartData= (module)=>{
    const method={
        crypto:'ExchangeFiatBalancesBarGraph',
        Cards:'CardsBalancesBarGraph',
        Banks:'BankFiatBalancesBarGraph',
        Exchange :'ExchangeFiatBalancesBarGraph',
        Wallets:'ExchangeFiatBalancesBarGraph',
        Payments:'ExchangeFiatBalancesBarGraph',
    }
    return adminApi.get(ApiControllers.dashboardController+method[module])
}
const getTransactionsChartData= (module,filters)=>{
    const currDate = new Date();
    const method={
        crypto:'ExchangeTransactionsLineGraph/',
        Cards:'CardsTransactionsLineGraph/',
        Banks:'BankTransactionsLineGraph/',
        Exchange :'ExchangeTransactionsLineGraph/',
        Wallets:'WalletsTransactionsLineGraph/',
        Payments:'PaymentsTransactionsLineGraph/',
        cryptoTransactions : 'CryptoTransactionsGraph/'
    }
    return adminApi.get(ApiControllers.dashboardController+method[module]+(filters.year || currDate.getFullYear()))
}

const getRecentTransactions=(module,filters)=>{
    const method={
        crypto:'ExchangeRecentTransactions/',
        Cards:'transactions/',
        Banks:'transactions/',
        Exchange :'ExchangeRecentTransactions/',
        Wallets:'transactions/',
        Payments:'transactions/',
    }
    const filterUrl=`${filters.pageNo}/${filters.pageSize}`
    return adminApi.get(ApiControllers.dashboardController+method[module]+filterUrl)
}
const getCardsKpi = (url) =>{
    return adminApi.get(ApiControllers.dashboardController+url);
}
const getYearLookup=()=>{
    return adminApi.get(ApiControllers.common+'yearsLookUp')
}

export { getKpiData,getPieChartData,getTransactionsChartData,getBalancesChartData,getRecentTransactions,getYearLookup,getCardsKpi }